import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import _classCallCheck from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _inherits from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module widget/widgetresize
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import Resizer from "./widgetresize/resizer";
import DomEmitterMixin from '@ckeditor/ckeditor5-utils/src/dom/emittermixin';
import global from '@ckeditor/ckeditor5-utils/src/dom/global';
import ObservableMixin from '@ckeditor/ckeditor5-utils/src/observablemixin';
import mix from '@ckeditor/ckeditor5-utils/src/mix';
import { throttle } from 'lodash-es';
import "../theme/widgetresize.css";
/**
 * The widget resize feature plugin.
 *
 * Use the {@link module:widget/widgetresize~WidgetResize#attachTo} method to create a resizer for the specified widget.
 *
 * @extends module:core/plugin~Plugin
 * @mixes module:utils/observablemixin~ObservableMixin
 */

var WidgetResize = /*#__PURE__*/function (_Plugin) {
  _inherits(WidgetResize, _Plugin);

  var _super = _createSuper(WidgetResize);

  function WidgetResize() {
    _classCallCheck(this, WidgetResize);

    return _super.apply(this, arguments);
  }

  _createClass(WidgetResize, [{
    key: "init",
    value: function init() {
      var _this = this;

      /**
       * The currently visible resizer.
       *
       * @protected
       * @observable
       * @member {module:widget/widgetresize/resizer~Resizer|null} #_visibleResizer
       */
      this.set('_visibleResizer', null);
      /**
       * References an active resizer.
       *
       * Active resizer means a resizer which handle is actively used by the end user.
       *
       * @protected
       * @observable
       * @member {module:widget/widgetresize/resizer~Resizer|null} #_activeResizer
       */

      this.set('_activeResizer', null);
      /**
       * A map of resizers created using this plugin instance.
       *
       * @private
       * @type {Map.<module:engine/view/containerelement~ContainerElement, module:widget/widgetresize/resizer~Resizer>}
       */

      this._resizers = new Map();
      var domDocument = global.window.document;
      this.editor.model.schema.setAttributeProperties('width', {
        isFormatting: true
      });
      this._observer = Object.create(DomEmitterMixin);

      this._observer.listenTo(domDocument, 'mousedown', function (event, domEventData) {
        if (!Resizer.isResizeHandle(domEventData.target)) {
          return;
        }

        var resizeHandle = domEventData.target;
        _this._activeResizer = _this._getResizerByHandle(resizeHandle);

        if (_this._activeResizer) {
          _this._activeResizer.begin(resizeHandle);
        }
      });

      this._observer.listenTo(domDocument, 'mousemove', function (event, domEventData) {
        if (_this._activeResizer) {
          _this._activeResizer.updateSize(domEventData);
        }
      });

      this._observer.listenTo(domDocument, 'mouseup', function () {
        if (_this._activeResizer) {
          _this._activeResizer.commit();

          _this._activeResizer = null;
        }
      });

      var redrawFocusedResizer = function redrawFocusedResizer() {
        if (_this._visibleResizer) {
          _this._visibleResizer.redraw();
        }
      };

      var redrawFocusedResizerThrottled = throttle(redrawFocusedResizer, 200); // 5fps
      // Redraws occurring upon a change of visible resizer must not be throttled, as it is crucial for the initial
      // render. Without it the resizer frame would be misaligned with resizing host for a fraction of second.

      this.on('change:_visibleResizer', redrawFocusedResizer); // Redrawing on any change of the UI of the editor (including content changes).

      this.editor.ui.on('update', redrawFocusedResizerThrottled); // Resizers need to be redrawn upon window resize, because new window might shrink resize host.

      this._observer.listenTo(global.window, 'resize', redrawFocusedResizerThrottled);

      var viewSelection = this.editor.editing.view.document.selection;
      viewSelection.on('change', function () {
        var selectedElement = viewSelection.getSelectedElement();
        _this._visibleResizer = _this._getResizerByViewElement(selectedElement) || null;
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._observer.stopListening();
    }
    /**
     * @param {module:widget/widgetresize~ResizerOptions} [options] Resizer options.
     * @returns {module:widget/widgetresize/resizer~Resizer}
     */

  }, {
    key: "attachTo",
    value: function attachTo(options) {
      var resizer = new Resizer(options);
      resizer.attach();

      this._resizers.set(options.viewElement, resizer);

      return resizer;
    }
    /**
     * Returns a resizer that contains a given resize handle.
     *
     * @protected
     * @param {HTMLElement} domResizeHandle
     * @returns {module:widget/widgetresize/resizer~Resizer}
     */

  }, {
    key: "_getResizerByHandle",
    value: function _getResizerByHandle(domResizeHandle) {
      var _iterator = _createForOfIteratorHelper(this._resizers.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var resizer = _step.value;

          if (resizer.containsHandle(domResizeHandle)) {
            return resizer;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Returns a resizer created for a given view element (widget element).
     *
     * @protected
     * @param {module:engine/view/containerelement~ContainerElement} viewElement
     * @returns {module:widget/widgetresize/resizer~Resizer}
     */

  }, {
    key: "_getResizerByViewElement",
    value: function _getResizerByViewElement(viewElement) {
      return this._resizers.get(viewElement);
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'WidgetResize';
    }
  }]);

  return WidgetResize;
}(Plugin);

export { WidgetResize as default };
mix(WidgetResize, ObservableMixin);
/**
 * Interface describing a resizer. It allows to specify the resizing host, custom logic for calculating aspect ratio, etc.
 *
 * @interface ResizerOptions
 */

/**
 * @member {module:engine/model/element~Element} module:widget/widgetresize~ResizerOptions#modelElement
 */

/**
 * @member {module:engine/view/containerelement~ContainerElement} module:widget/widgetresize~ResizerOptions#viewElement
 */

/**
 * @member {module:engine/view/downcastwriter~DowncastWriter} module:widget/widgetresize~ResizerOptions#downcastWriter
 */

/**
 * A callback to be executed once the resizing process is done.
 *
 * It receives a `Number` (`newValue`) as a parameter.
 *
 * For example, {@link module:image/imageresize~ImageResize} uses it to execute the image resize command
 * which puts the new value into the model.
 *
 * ```js
 * {
 *	modelElement: data.item,
 *	viewElement: widget,
 *	downcastWriter: conversionApi.writer,
 *
 *	onCommit( newValue ) {
 *		editor.execute( 'imageResize', { width: newValue } );
 *	}
 * };
 * ```
 *
 *
 * @member {Function} module:widget/widgetresize~ResizerOptions#onCommit
 */

/**
 * @member {Function} module:widget/widgetresize~ResizerOptions#getResizeHost
 */

/**
 * @member {Function} module:widget/widgetresize~ResizerOptions#isCentered
 */